export default __webpack_public_path__ + "static/showroom_321-7a3f1528b13e09450e6761bea54d8b40.jpg";